import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import api from '../services/api';
import AnnouncementBar from '../components/AnnouncementBar';
import Footer from '../components/Footer';
import SponsorsSection from '../components/SponsorsSection';
import ScrollToTop from '../components/ScrollToTop';
import TornPaperWrapper from '../components/TornPaperWrapper';
import { getCmsImagePath } from '../cms/cmsData';
import './EhabTawfik.css';

const TikTokIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.8a8.24 8.24 0 0 0 4.76 1.52V6.87a4.84 4.84 0 0 1-1-.18z"/>
  </svg>
);

const SpotifyIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
  </svg>
);

const FacebookIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_ehab_fb)">
      <path d="M16 1.71429V14.2857C16 15.2321 15.2321 16 14.2857 16H11.2393V9.67143H13.4036L13.7143 7.25714H11.2393V5.71429C11.2393 5.01429 11.4321 4.53929 12.4357 4.53929H13.7143V2.38214C13.4929 2.35357 12.7357 2.28571 11.85 2.28571C10.0071 2.28571 8.74286 3.41071 8.74286 5.47857V7.26071H6.57143V9.675H8.74643V16H1.71429C0.767857 16 0 15.2321 0 14.2857V1.71429C0 0.767857 0.767857 0 1.71429 0H14.2857C15.2321 0 16 0.767857 16 1.71429Z" fill="#1D1D1D"/>
    </g>
    <defs>
      <clipPath id="clip0_ehab_fb">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const XIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5997 0.768311H15.0543L9.69318 6.89434L16 15.2316H11.063L7.19339 10.1764L2.77097 15.2316H0.312907L6.04607 8.67791L0 0.768311H5.06215L8.55628 5.38891L12.5997 0.768311ZM11.7375 13.7644H13.0969L4.3216 2.15901H2.86136L11.7375 13.7644Z" fill="#1D1D1D"/>
  </svg>
);

const YoutubeIcon = () => (
  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.6661 1.76053C15.4815 1.06628 14.9396 0.521421 14.2512 0.336873C13.0033 0 8 0 8 0C8 0 2.9967 0 1.74881 0.336873C1.06042 0.521421 0.518491 1.06628 0.333944 1.76053C0 3.01721 0 5.63603 0 5.63603C0 5.63603 0 8.25485 0.333944 9.51154C0.518491 10.2058 1.06042 10.7272 1.74881 10.9118C2.9967 11.2486 8 11.2486 8 11.2486C8 11.2486 13.0033 11.2486 14.2512 10.9118C14.9396 10.7272 15.4815 10.2029 15.6661 9.51154C16 8.25485 16 5.63603 16 5.63603C16 5.63603 16 3.01721 15.6661 1.76053ZM6.36543 8.01465V3.25741L10.5456 5.63603L6.36543 8.01465Z" fill="#1D1D1D"/>
  </svg>
);

const SnapchatIcon = () => (
  <svg width="16" height="16" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm127.4 379.7c-4.3 7.1-12.4 10.9-20.8 10.9-4.1 0-8.2-1-12-3.1-37.7-20.8-81-22.7-133.3-8.3-8.2 2.2-16.7-2.6-18.9-10.8s2.6-16.7 10.8-18.9c58.5-16.2 108.5-13.4 151.8 10.4 7.4 4.1 10.4 13.4 6.4 20.8h16zm34.4-71.8c-4.9 8-15.3 10.6-23.4 5.7-43.2-25.8-109-33.3-160.1-18.2-9.2 2.7-18.9-2.5-21.6-11.7s2.5-18.9 11.7-21.6c58.5-17.3 131-8.9 180.5 20.8 8.1 4.9 10.6 15.4 5.7 23.4 7.2.6zm3.6-74.8C367 199.1 213.3 194.3 124.3 221.7c-11 3.4-22.7-2.8-26.1-13.9-3.4-11 2.8-22.7 13.9-26.1 102.1-31.4 271.8-25.4 379.1 39.2 9.9 5.9 13.2 18.6 7.3 28.5-5.8 9.9-18.6 13.2-28.5 7.3l.4.2z" fill="#1D1D1D"/>
  </svg>
);

const videos = [
  { id: 'cIHvtJVG0OA', title: 'Ehab Tawfik - Allah 3aleik Ya Sidi', views: '3.6M Views' },
  { id: 'GEBsANAK0L0', title: 'Ehab Tawfik - Sahrany | \u0625\u064A\u0647\u0627\u0628 \u062A\u0648\u0641\u064A\u0642 - \u0633\u062D\u0631\u0627\u0646\u064A', views: '46M Views' },
  { id: 'hKxpq_lFFhI', title: 'Ehab Tawfik - Tetraga Feya - Master I \u0625\u064A\u0647\u0627\u0628 \u062A\u0648\u0641\u064A\u0642 - \u062A\u062A\u0631\u062C\u0649 \u0641\u064A\u0627 - \u0645\u0627\u0633\u062A\u0631', views: '560K Views' },
  { id: 'uF8b0mh7idc', title: 'Ehab Tawfik - Ya A7la Menhom', views: '13M Views' },
  { id: 'fAUkwoaIQAs', title: 'Ehab Tawfik - Aktar Men Keda Eah / \u0625\u064A\u0647\u0627\u0628 \u062A\u0648\u0641\u064A\u0642 - \u0623\u0643\u062A\u0631 \u0645\u0646 \u0643\u062F\u0629 \u0623\u064A\u0629', views: '27M Views' },
  { id: 'uF8b0mh7idc', title: 'Ehab Tawfik - El Sahra Gamda \u0625\u064A\u0647\u0627\u0628 \u062A\u0648\u0641\u064A\u0642 - \u0627\u0644\u0633\u0647\u0631\u0629 \u062C\u0627\u0645\u062F\u0629', views: '118K Views' },
];

const EhabTawfik = () => {
  const [bioExpanded, setBioExpanded] = useState(false);
  const [allowed, setAllowed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const response = await api.getPublicConfig();
        if (response?.success && response.data?.ehab_tawfik_enabled) {
          setAllowed(true);
        } else {
          navigate('/music', { replace: true });
        }
      } catch {
        navigate('/music', { replace: true });
      }
    };
    checkAccess();
  }, [navigate]);

  if (!allowed) return null;

  return (
    <div className="page-wrapper">
      <AnnouncementBar />
      
      <section className="hero-section">
        <div className="hero-background-wrapper">
          <video src={"/hero-final.mp4"} alt="oc mena festival" className="hero-background-video" autoPlay muted loop playsInline />
          <div className="hero-gradient-overlay"></div>
        </div>

        <TornPaperWrapper>
          {/* ===== TOP HEADER ===== */}
          <div className="ehab-top-header">
            <div className="ehab-top-header-left">
              <h1>Ehab Tawfik at the OC MENA Festival!</h1>
              <p>Performing Friday, June 19, 2026 — Community Stage (Fairgrounds 8:30 PM)</p>
            </div>
            <a href="/festival-tickets" className="ehab-buy-btn" title="Buy Tickets">Buy Tickets</a>
          </div>

          {/* ===== SPLIT LAYOUT ===== */}
          <div className="ehab-split-layout">
            {/* LEFT COLUMN: Photo, Flag, Details */}
            <div className="ehab-left-col">
              <img loading="lazy" src={getCmsImagePath('ehabPortrait', '/ehab.webp')} alt="Ehab Tawfik" className="ehab-portrait" />
              <img loading="lazy" src={getCmsImagePath('ehabFlag', '/egypt.webp')} alt="Egypt Flag" className="ehab-flag-img" />

              <div className="ehab-details">
                <h3>Details</h3>
                <div className="ehab-details-label">Background</div>
                <div className="ehab-details-value">Egyptian</div>
                <div className="ehab-details-label">Socials</div>
                <ul className="ehab-socials-list">
                  <li>
                    <a href="https://www.instagram.com/ehabtawfiksinger/" target="_blank" rel="noopener noreferrer" title="Ehab Tawfik on Instagram">
                      <Instagram size={18} />
                      Instagram <span className="ehab-social-followers">(339K+)</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.tiktok.com/@EhabTawfikSinger" target="_blank" rel="noopener noreferrer" title="Ehab Tawfik on TikTok">
                      <TikTokIcon />
                      TikTok <span className="ehab-social-followers">(849K+ Likes)</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://open.spotify.com/" target="_blank" rel="noopener noreferrer" title="Ehab Tawfik on Spotify">
                      <SpotifyIcon />
                      Spotify
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/EhabTawfikSinger" target="_blank" rel="noopener noreferrer" title="Ehab Tawfik on Facebook">
                      <FacebookIcon />
                      Facebook <span className="ehab-social-followers">(4.8M+)</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://x.com/EhabTawfikEG" target="_blank" rel="noopener noreferrer" title="Ehab Tawfik on X">
                      <XIcon />
                      X (Twitter)
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/channel/UCxqsTKQbUTlAukuor_V79mA" target="_blank" rel="noopener noreferrer" title="Ehab Tawfik on YouTube">
                      <YoutubeIcon />
                      YouTube <span className="ehab-social-followers">(95M+ views)</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.snapchat.com/@ehabtawfikeg" target="_blank" rel="noopener noreferrer" title="Ehab Tawfik on Snapchat">
                      <SnapchatIcon />
                      Snapchat
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* RIGHT COLUMN: Bio, Videos */}
            <div className="ehab-right-col">
              <h2 className="ehab-artist-name-heading">Ehab Tawfik</h2>

              <h2 className="ehab-bio-heading">Bio</h2>
              <div className={`ehab-bio-container${bioExpanded ? ' expanded' : ''}`}>
                <p>
                  <strong>Ehab Tawfik</strong> is a celebrated Egyptian singer and one of the most respected voices in contemporary Arabic music. Born on January 7, 1966, Tawfik discovered his passion for music at a young age and began studying the oud (lute) during childhood. His early dedication to both performance and musical scholarship shaped a career that blends artistic excellence with deep academic knowledge of Arabic singing traditions.
                </p>
                <p>
                  He launched his professional music career in 1989 with the single <em>Dany</em>, followed by his debut album <em>Ekminny</em>. Tawfik gained widespread recognition in the mid-1990s with the hit song <em>W Adda Lil</em>, which helped establish him as a major figure in the Arab pop scene. Known for his warm voice, expressive delivery, and carefully crafted melodies, he quickly built a loyal audience across the Middle East and beyond.
                </p>
                <p>
                  In addition to his successful recording career, Tawfik pursued advanced academic studies in music. He earned a Master's degree in 1995 with a thesis on Egyptian songs in the twentieth century and later completed a Doctorate in Music and Arabic singing in 2002, focusing on the performance methods of Arabic vocal traditions in Egypt.
                </p>
                <p>
                  With more than 15 albums released over three decades, <strong>Ehab Tawfik</strong> remains a beloved and influential artist whose music continues to resonate with audiences throughout the Arab world.
                </p>
                {!bioExpanded && <div className="ehab-bio-fade"></div>}
              </div>
              <button className="ehab-read-more" onClick={() => setBioExpanded(!bioExpanded)}>
                {bioExpanded ? 'Read less' : 'Read More'}
              </button>

              {/* ===== BUY TICKETS CENTER ===== */}
              <div className="ehab-center-btn">
                <a href="/festival-tickets" className="ehab-buy-btn" title="Buy Tickets">Buy Tickets</a>
              </div>

              {/* ===== YOUTUBE x MUSIC ===== */}
              <h2 className="ehab-youtube-heading">YouTube x Music</h2>
              <div className="ehab-videos-grid">
                {videos.map((video, index) => (
                  <div className="ehab-video-card" key={`${video.id}-${index}`}>
                    <div className="video-embed-wrapper">
                      <iframe
                        src={`https://www.youtube.com/embed/${video.id}`}
                        title={video.title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>
                    </div>
                    <div className="ehab-video-title">{video.title}</div>
                    <div className="ehab-video-views">{video.views}</div>
                  </div>
                ))}
              </div>

              {/* ===== BUY TICKETS CENTER ===== */}
              <div className="ehab-center-btn">
                <a href="/festival-tickets" className="ehab-buy-btn" title="Buy Tickets">Buy Tickets</a>
              </div>
            </div>
          </div>

        </TornPaperWrapper>

        <div className="lanterns-container">
          <img loading="lazy" src={getCmsImagePath('lanterns', '/lanterns.webp')} alt="festival lanterns" className="lanterns-image" />
        </div>
      </section>

      <SponsorsSection />
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default EhabTawfik;
